import styled from "styled-components";

export default styled.div`
  .noti-list {
    height: 50vh;
    max-height: 500px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 40px;

    .loading-all {
      padding: 8px 0px;
      text-align: center;
    }

    .noti-group {
      h4 {
        font-size: var(--font-size-lg);
        font-weight: 600;
        margin-bottom: var(--size);
      }
    } 

    .noti {
      padding: 8px 0px;
      border-bottom: 1px solid #EAECF0;

      &:last-of-type {
        border-bottom: 0px;
      }

      .noti-title {
        display: flex;

        h5 {
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          flex: 1;
        }

        span {
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: #667085;
        }
      }

      p {
        margin-bottom: 0px;
        color: #667085;
        font-weight: 500;
        font-size: 14px;
      }
    }
  }
`;
